export enum AppOrigin {
  Production = "https://mem.ai",
}

export const APP_CONFIG = {
  URLS: {
    LANDING_PAGE: "https://get.mem.ai",
    PRODUCT_UPDATES: "https://get.mem.ai/product-updates",
    FAQ: "https://get.mem.ai/faq",
    HELP_AND_SUPPORT: "https://support.mem.ai",
    YOUTUBE: "https://mem.ai/youtube",
    ZAPIER_INTEGRATION: "https://api.mem.ai/api/v2/integrations/zapier/connect",
    ZAPIER_VIDEO_URL: "https://www.youtube.com/watch?v=Z9m6BYqTY7A",
    ZAPIER_VIDEO_EMBED_URL: "https://www.youtube.com/embed/Z9m6BYqTY7A?si=0NeDSDiruWKwUXBB",
    FEATURE_REQUESTS: "https://support.mem.ai/share-feedback/",
    BUG_REPORTS: "https://support.mem.ai/request-support/",
    SHARE_FEEDBACK: "https://support.mem.ai/share-feedback-form",
    REQUEST_SUPPORT: "https://support.mem.ai/article/7-request-support",
    REDIRECT: "https://get.mem.ai/redirect",
    IOS_APP_V2: "https://testflight.apple.com/join/BD3PEkyq",
    IOS_APP_GUIDE: "https://get.mem.ai/get-ios-app",
    MAC_APP: "https://get.mem.ai/get-mac-app",
    WINDOWS_APP: "https://get.mem.ai/get-windows-app",
  },
  SYSTEM: {
    HEALTH_CHECK_URL: "https://backend-prod.mem.engineering/api/v2/health",
  },
};
